// Foundations
import { Component, HostBinding, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

// Models
import { CanDeactivateComponent } from 'src/app/models/can-deactivate-component.model';

@Component({
  selector: 'app-preferences-page',
  templateUrl: './preferences-page.component.html',
  styleUrls: ['./preferences-page.component.scss'],
})
export class PreferencesPageComponent
  implements OnInit, CanDeactivateComponent
{
  @HostBinding('class') class = 'page-config';

  constructor(private titleService: Title) {
    this.titleService.setTitle('Client Portal - Communication Preferences');
  }

  canDeactivate() {
    return true;
  }

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {}

  // Public Methods
  // ------------------------------------------------------------------------------------
}
